import { Task, TaskStatus } from "datamodel/task";

const getTaskNextStatus = (task: Task) =>
  task.properties.status === TaskStatus.ValidationInProgress
    ? TaskStatus.Validated
    : TaskStatus.Labeled;

export default getTaskNextStatus;
